import FeatureSplashWrapper from './FeatureSplashWrapper'
import './GetStartedSplashScreen.scss'

const GetStartedSplashScreen = () => {
  return (
    <FeatureSplashWrapper>
      <div className='mb-6 get-start-container' style={{ paddingRight: '30px !important' }}>
        <p className='mb-4 fs-4 fw-bold'>You're just a few minutes away from activating your Digital Business Card.
        Follow these quick steps to get everything set up:</p>
        <div className='mb-8'>
          <div className='d-flex align-items-start mb-2'>
            <span className='step-number-purple me-3'>1</span>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>Create your first template</strong> - Add your dealership logo, brand colours, and your offer/promotion.
            </span>
          </div>
          <div className='d-flex align-items-start mb-2'>
            <span className='step-number-purple me-3'>2</span>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>Create your B-Card</strong> - Upload your profile photo and personalise your digital card.
              Activate your Flow & Automation.
            </span>
          </div>
          <div className='d-flex align-items-start mb-2'>
            <span className='step-number-purple me-3'>3</span>
            <span className='text-gray-800 fw-semibold fs-6'>
              <strong>Activate the Flow &amp; Automation sequence</strong> - Turn on the automated sequence so every new lead is captured and followed up instantly.
            </span>
          </div>
        </div>
      </div>
      {/* Fake content for height matching */}
      <div className='fake-height-spacer' aria-hidden='true'></div>
  </FeatureSplashWrapper>
  )
}

export default GetStartedSplashScreen
